<template>
  <div v-if="visible" class="verify-dialog-container">
    <!-- 背景遮罩 -->
    <div class="dialog-mask" @click="handleClose"></div>

    <!-- 弹窗内容 -->
    <div class="verify-dialog">
      <!-- 标题 -->
      <div class="dialog-header" v-if="checkCode==1 || checkCode==2">
        <span class="title">{{checkCode==1?'验证身份':'设置新密码'}}</span>
        <i class="el-icon-close close-icon" @click="handleClose"></i>
      </div>

      <!-- 表单内容 -->
      <div  class="dialog-content">
        <el-form v-if="checkCode==1" :model="verifyForm" :rules="rules" ref="verifyForm" label-width="80px">
          <!-- 手机号码输入 -->
          <el-form-item label="手机号" prop="phone">
            <el-input
              v-model="verifyForm.phone"
              placeholder="输入登录手机号"
              clearable
            ></el-input>
            <div v-if="phoneError" class="error-text">{{ phoneError }}</div>
          </el-form-item>

          <!-- 验证码输入 -->
          <el-form-item label="验证码" prop="captcha">
            <div class="captcha-input-group">
              <el-input
                v-model="verifyForm.captcha"
                placeholder="输入验证码"
                clearable
              ></el-input>
              <el-button
                :disabled="countdown > 0 || !verifyForm.phone"
                @click="isExistUser"
                class="captcha-btn"
              >
                {{ countdown > 0 ? `${countdown}秒后重试` : '发送验证码' }}
              </el-button>
            </div>
            <div v-if="captchaError" class="error-text">{{ captchaError }}</div>
          </el-form-item>

          <!-- 立即验证按钮 -->
          <div class="verify-btn-container">
            <el-button
              type="primary"
              @click="handleVerify"
              :loading="verifying"
              class="verify-btn"
            >
              立即验证
            </el-button>
          </div>
        </el-form>
        <el-form v-else-if="checkCode===2" :model="passwordForm" :rules="passwordrules" ref="passwordForm" label-width="100px">
          <!-- 手机号码输入 -->
          <el-form-item label="新密码" prop="password">
            <el-input
              type="password"
              show-password
              v-model="passwordForm.password"
              placeholder="输入新密码"
              clearable
            ></el-input>
          </el-form-item>

          <!-- 验证码输入 -->
          <el-form-item label="确认新密码" prop="passwordtwo">
            <div class="captcha-input-group">
              <el-input
                type="password"
                show-password
                v-model="passwordForm.passwordtwo"
                placeholder="确认新密码"
                clearable
              ></el-input>
            </div>
          </el-form-item>

          <!-- 立即验证按钮 -->
          <div class="verify-btn-container">
            <el-button
              type="primary"
              @click="submit"
              :loading="verifying"
              class="verify-btn"
            >
              确定
            </el-button>
          </div>
        </el-form>
        <div v-else style="display: flex; justify-content: center;align-items: center;flex-direction: column;height: 260px;font-size: 22px; gap: 40px;">
          <div style="display: flex;"><div style="margin-right: 5px;"><el-image style="width: 30px;height: 30px" :src="submitImg"/></div> 密码重置成功</div>
          <div style="cursor: pointer;color: #02a7f0;  text-decoration: underline;" @click="handleClose"> 去登录</div>
        </div>
        <!-- 底部说明 -->
        <div v-if="checkCode==1" class="footer-tips">
          <div>1. 找回步骤: 验证身份-设置新密码</div>
          <div style="text-align: left;">2. 发送验证码后，您可以在手机短信中获取（1分钟内未收到，建议在垃圾短信中查看）</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VerifyIdentityDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    // 手机号验证规则
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        this.phoneError = ''
        callback(new Error('请输入手机号码'))
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        this.phoneError = ''
        callback(new Error('请输入正确的手机号码'))
      } else {
        callback()
      }
    }

    // 验证码验证规则
    const validateCaptcha = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入验证码'))
      } else if (!/^\d{6}$/.test(value)) {
        callback(new Error('验证码必须是6位数字'))
      } else {
        callback()
      }
    }

    // 密码位数验证
    const validatePassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入新密码'))
      } else if (value.length < 6) {
        callback(new Error('新密码必须大于等于6位'))
      } else {
        callback()
      }
    }

    const validatePasswordTwo = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请确认新密码'))
      } else if (value.length < 6) {
        callback(new Error('确认新密码必须大于等于6位'))
      } else if (value !== this.passwordForm.password) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }

    return {
      verifyForm: {
        phone: '',
        captcha: ''
      },
      passwordForm: {
        password: '',
        passwordtwo: ''
      },
      rules: {
        phone: [
          { required: true, validator: validatePhone, trigger: 'blur' }
        ],
        captcha: [
          { required: true, validator: validateCaptcha, trigger: 'blur' }
        ]
      },
      passwordrules: {
        password: [
          { required: true, validator: validatePassword, trigger: 'blur' }
        ],
        passwordtwo: [
          { required: true, validator: validatePasswordTwo, trigger: 'blur' }
        ]
      },
      submitImg: require('@/assets/images/submit.png'),
      checkCode: 1,
      phoneError: '',
      captchaError: '',
      countdown: 0,
      timer: null,
      verifying: false
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.resetForm()
      }
    }
  },
  methods: {
    // 发送验证码
     sendCaptcha () {
       let jsondata = {
           phone: this.verifyForm.phone,
           type: '4'
       }
       const loading = this.$loading({
         lock: true,
         text: '提交中...',
         target: '.main',
         spinner: 'el-icon-loading',
         background: 'rgba(0, 0, 0, .7)'
       })
       var p1 = this.customGlobal.postHttpClient(
         this.customGlobal.serverUrl.getPhoneVerificationCodeForActivity,
         this.customGlobal.serverUrl.orgBaseURI,
         {"Content-Type": "application/x-www-form-urlencoded"},
         this.qs.stringify({ jsondata: JSON.stringify(jsondata) }))
       p1.then((res) => {
         loading.close()
         if (res.data.status === 'success') {
           // this.checkCode = res.data.checkCode
           this.startCountdown()
           this.$message.success('验证码已发送至您的手机')
         } else {
           this.captchaError = res.data.msg || '发送验证码失败'
         }
       }, error => {
         loading.close()
       }).catch((res) => {
           loading.close()
       })
    },

    // 开始倒计时
    startCountdown() {
      this.countdown = 60
      this.timer = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) {
          clearInterval(this.timer)
          this.timer = null
        }
      }, 1000)
    },
    async isExistUser () {
      // 使用回调函数方式验证
      this.$refs.verifyForm.validateField('phone', (errorMessage) => {
        if (errorMessage) {
          this.phoneError = ''
          // 验证失败
          return
        }
        const loading = this.$loading({
          lock: true,
          text: '提交中...',
          target: '.main',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, .7)'
        })
        var p1 = this.customGlobal.postHttpClient(
          this.customGlobal.serverUrl.isExistUser,
          this.customGlobal.serverUrl.orgBaseURI,
          {"Content-Type": "application/json"},
          {username:this.verifyForm.phone})
        p1.then((res) => {
          loading.close()
          if (res.data.status === 'success') {
            this.sendCaptcha()
            this.phoneError = ''
          } else {
            this.phoneError = res.data.msg
          }
        }, error => {
          loading.close()
        }).catch((res) => {
          loading.close()
        })
      })
    },
    // 立即验证
    handleVerify () {
      let jsondata = {
        phone: this.verifyForm.phone,
        check_code: this.verifyForm.captcha,
        type: '1'
      }
      this.$refs.verifyForm.validate((valid) => {
        if (valid) {
          this.verifying = true
          this.phoneError = ''
          this.captchaError = ''
          var p1 = this.customGlobal.postHttpClient(
            this.customGlobal.serverUrl.postBankVerificationCode,
            this.customGlobal.serverUrl.orgBaseURI,
            {"Content-Type": "application/x-www-form-urlencoded"},
            this.qs.stringify({ jsondata: JSON.stringify(jsondata) }))
          p1.then((res) => {
            this.verifying = false
            if (res.data.status === 'success') {
              this.checkCode = 2
              this.$message.success('验证成功')
            } else {
              this.captchaError = res.data.msg || '发送验证码失败'
            }
          }, error => {
            this.captchaError = '发送验证码失败'
            this.verifying = false
          }).catch((res) => {
            this.captchaError = '发送验证码失败'
            this.verifying = false
          })
        }
      })
    },
    // 修改密码
    submit () {
      let jsondata = {
        phone: this.verifyForm.phone,
        check_code: this.verifyForm.captcha,
        type: '1',
        password: this.customGlobal.md5(this.passwordForm.password)
      }
      this.$refs.passwordForm.validate((valid) => {
        if (valid) {
          this.verifying = true
          var p1 = this.customGlobal.postHttpClient(
            this.customGlobal.serverUrl.postBankMerChangePassForPhoneVerificationCode,
            this.customGlobal.serverUrl.orgBaseURI,
            {"Content-Type": "application/x-www-form-urlencoded"},
            this.qs.stringify({ jsondata: JSON.stringify(jsondata) }))
          p1.then((res) => {
            this.verifying = false
            if (res.data.status === 'success') {
              this.checkCode = 3
              this.$message.success('密码修改成功')
            } else {
              this.$message.error('密码修改失败')
            }
          }, error => {
            this.$message.error('密码修改失败')
            this.verifying = false
          }).catch((res) => {
            this.$message.error('密码修改失败')
            this.verifying = false
          })
        }
      })
    },

    // 关闭弹窗
    handleClose() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      this.$emit('update:visible', false)
      this.$emit('close')
    },

    // 重置表单
    resetForm () {
      this.verifyForm.phone = ''
      this.verifyForm.captcha = ''
      this.phoneError = ''
      this.captchaError = ''
      this.countdown = 0
      this.checkCode = 1
      this.verifying = false
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      if (this.$refs.verifyForm) {
        this.$refs.verifyForm.clearValidate()
      }
      if (this.$refs.passwordForm) {
        this.$refs.passwordForm.clearValidate()
      }
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  }
}
</script>

<style scoped>
.verify-dialog-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dialog-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
}

.verify-dialog {
  position: relative;
  width: 400px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
}

.dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #e8e8e8;
}

.dialog-header .title {
  display: flex;
  justify-content: center;
  width: 90%;
  margin-left: 10px;
  font-size: 16px;
  color: #333;
  font-weight: 600;
}

.close-icon {
  cursor: pointer;
  color: #999;
  font-size: 16px;
}

.close-icon:hover {
  color: #666;
}

.dialog-content {
  padding: 20px 20px 10px;
}

.service-tip {
  text-align: center;
  margin-bottom: 10px;
  font-weight: bold;
  color: #333;
}

.id-card-tip {
  text-align: center;
  margin-bottom: 20px;
  color: #666;
  font-size: 14px;
}

.captcha-input-group {
  display: flex;
  gap: 10px;
}

.captcha-input-group .el-input {
  flex: 1;
}

.captcha-btn {
  color:  #409EFF;
  border-color: #409EFF;
  width: 110px;
}

.error-text {
  display: flex;
  color: #f56c6c;
  font-size: 12px;
  margin-top: 0px;
  margin-bottom: -30px;
}

.verify-btn-container {
  text-align: center;
}

.verify-btn {
  width: 200px;
  height: 40px;
  background-color: #409EFF;
  border-color: #409EFF;
  line-height: 40px;
  padding: 0 15px;
}

.footer-tips {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  flex-wrap: wrap;
  margin-top: 30px;
  padding-top: 10px;
  border-top: 1px solid #f0f0f0;
  font-size: 11px;
  color: #999;
}

</style>



// WEBPACK FOOTER //
// src/components/verifition/VerifyIdentityDialog.vue